import { EventBus, TEMPLATE_MODIFIED } from '@/model/EventBus'
import { mapGetters } from 'vuex'
import { not, empty, defined } from 'junctions-fp'
export default {
  async created() {
    this.dictionnary = await this.getLanguages
    this.editor.on('selectedObject', this.selectItem)
    this.editor.on('unselected', this.unSelectItem)
    this.editor.on('addItem', this.setHasElement)
    this.editor.on('removeItem', this.setHasElement)
    this.editor.on('loadedTemplate', this.setHasElement)
  },
  beforeDestroy() {
    this.editor.off('addItem', this.setHasElement)
    this.editor.off('removeItem', this.setHasElement)
    this.editor.off('loadedTemplate', this.setHasElement)
    this.editor.off('selectedObject', this.selectItem)
    this.editor.off('unselected', this.unSelectItem)
  },
  mounted() {
    this.hasElement = defined(this.editor._getCustomObjects()) ? not(empty(this.editor._getCustomObjects())) : false
    const selected = defined(this.editor.getCurrentSelectedObject())
    this.isImage = this.hasElement && selected && this.editor.getCurrentSelectedObject().type === 'image'
    this.isText = this.hasElement && selected && this.editor.getCurrentSelectedObject().type === 'textbox'
  },
  data() {
    return {
      dictionnary: null,
      isImage: false,
      hasElement: false,
      isText: false
    }
  },
  props: {
    editor: Object
  },
  computed: {
    ...mapGetters(['getLanguages', 'currentTemplate'])
  },
  methods: {
    templateModified() {
      EventBus.$emit(TEMPLATE_MODIFIED)
    },
    changeMenu(menu) {
      this.$emit('changeMenu', menu)
    },
    setHasElement(item) {
      this.hasElement = not(empty(this.editor._getCustomObjects()))
    },
    selectItem(item) {
      this.isImage = item.type === 'image'
      this.isText = item.type === 'textbox'
    },
    unSelectItem(item) {
      this.isImage = false
      this.isText = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/menu/menu-default.js